import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { FONTS, TYPOGRAPHY } from '@/styles';
import { StyleProp, Text, View, ViewStyle } from 'react-native';

interface Props {
  dateLabel: string;
  style?: StyleProp<ViewStyle>;
  textColor?: string; // Custom text color for white variant
  variant: 'white' | 'pill'; // 'white' for volume banner, 'pill' for promo card
}

export const VolumePromotionDateLabel: React.FC<Props> = ({
  dateLabel,
  style,
  variant,
  textColor,
}) => {
  const [styles] = useStyles();

  if (!dateLabel) {
    return null;
  }

  return (
    <View
      style={[
        styles.baseContainer,
        variant === 'white' ? styles.whiteContainer : styles.pillContainer,
        style,
      ]}
    >
      <Text
        style={[
          TYPOGRAPHY.smallLabel,
          styles.baseText,
          variant === 'pill' && styles.pillText,
          textColor && { color: textColor },
        ]}
      >
        {dateLabel}
      </Text>
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  baseContainer: {
    alignSelf: 'flex-start',
    borderRadius: 16,
    justifyContent: 'center',
    maxHeight: 48,
    paddingHorizontal: 6,
    paddingVertical: 2,
  },
  baseText: {
    ...FONTS.primaryBold,
  },
  pillContainer: {
    backgroundColor: theme.colors.divider,
  },
  pillText: {
    color: theme.colors.primary,
  },
  whiteContainer: {
    backgroundColor: theme.colors.white,
    flexDirection: 'row',
    marginBottom: 6,
  },
}));
